/* eslint-disable no-unneeded-ternary */
import React, { useState, useEffect } from 'react';
import TitleBar from 'components/Common/TitleBar';
import Ad from 'models/business/Ad';
import Asset from 'models/business/Asset';
// import Grid from '@material-ui/core/Grid';
import { useHistory, useLocation } from 'react-router-dom';
import API from 'api';
import ActionButton from 'components/Common/ActionButton';
import HideableContainer from 'components/Common/HideableContainer';
import AdvertisingWays from './AdvertisingWays';
import TargetSetting from './TargetSetting';
import AdCardSetting from './AdCardSetting';
import SelectMarket from './SelectMarket';
import ProcessionPopup from './ProcessionPopup';
// eslint-disable-next-line no-unused-vars
import AdvertisingGoal, { Categories as GoalCategories } from './AdvertisingGoal';

import Styles from './index.module.css';

const steps = [
  '我的廣告',
  '新增廣告單元',
];

function AdSetting() {
  const [ad, setAd] = useState(new Ad());
  const [activeCard, setActiveCard] = useState('');
  const [marketPopulated, setMarketPopulated] = useState(false);
  const [targetPopulated, setTargetPopulated] = useState(false);
  const [popupAction, setPopupAction] = useState();
  const [validFromAdSettings, setValidFromAdSettings] = useState(false);
  const location = useLocation();
  const history = useHistory();

  const saveAd = async () => {
    let result = await API.mall.getMallAssets(ad.market.id);
    if (result.error) {
      alert(result.error.errorMsg);
      return null;
    }

    const marketFeeds = (result.resultData || []).map((a) => new Asset(a));
    if (!marketFeeds.length) return null;
    ad.marketContentFeedId = marketFeeds[0].id;

    result = await API.ad.postNewAd(ad.toNewJSON());
    if (result.error) {
      alert(result.error.errorMsg);
      return null;
    }

    return new Ad(result.resultData);
  };

  const handleValidFromAdSettings = (value) => {
    setValidFromAdSettings(value);
  };

  const saveAndReturnToDashboard = () => {
    saveAd().then((ok) => {
      if (!ok) return;
      setPopupAction(() => () => {
        history.push('/MyAds');
      });
    });
  };

  const saveAndContinueToSettings = async () => {
    let newAd = await saveAd();
    if (!newAd) return;

    if (location.state?.ad) {
      newAd.loadCopy(location.state.ad);
      const result = await API.ad.postUpdateAd(newAd.toJSON());
      if (result.error) {
        alert(result.error.errorMsg);
        return;
      }
      newAd = new Ad(result.resultData);
    }

    if (newAd.isGoogle) {
      setPopupAction(() => () => history.push('/GoogleResourceSetting', { ad: newAd, firstEdit: true }));
    } else {
      setPopupAction(() => () => history.push('/FbResourceSetting', { ad: newAd, firstEdit: true }));
    }
  };

  const handleNextStep = () => {
    if (!marketPopulated) {
      if (ad.market.id) {
        setMarketPopulated(true);
        setActiveCard('target');
      }
    } else if (!targetPopulated) {
      setTargetPopulated(true);
      setActiveCard('setting');
    }
  };

  useEffect(() => {
    if (location?.state?.ad) {
      const newAd = location.state.ad.clone();
      newAd.name = '';
      newAd.dayBudget = 0;
      newAd.advertisingGoal = GoalCategories.DevelopCustomers;
      newAd.contentFeedId = '';
      setAd(newAd);
      setMarketPopulated(true);
      setTargetPopulated(true);
    }
  }, [location]);

  return (
    <div className={Styles.adSettingContainer}>
      <div className={Styles.adSettingForm}>
        <div>
          <div style={{ marginBottom: 47 }}>
            <TitleBar steps={steps} />
          </div>
          <div style={{ marginBottom: 25 }}>
            <AdvertisingGoal ad={ad} onChangeAd={setAd} />
          </div>
          <div style={{ marginBottom: 25 }}>
            <AdvertisingWays
              ad={ad}
              onChangeAd={(newAd) => {
                if (!newAd.market.id) setActiveCard('market');
                setAd(newAd);
              }}
            />
          </div>
          <div style={{ marginBottom: 36 }}>
            <SelectMarket
              ad={ad}
              onChangeAd={setAd}
              active={activeCard === 'market'}
              onSetActive={() => {
                setActiveCard('target');
                setMarketPopulated(true);
              }}
            />
          </div>
          <HideableContainer className={Styles.targetSettingContainer} hidden={!ad.advertisingGoal}>
            <div style={{ marginBottom: 25 }}>
              <TargetSetting
                ad={ad}
                onChangeAd={setAd}
                disabled={!marketPopulated}
                active={activeCard === 'target'}
                onSetActive={() => setActiveCard('target')}
              />
            </div>
          </HideableContainer>
          <HideableContainer hidden={!ad.market.id || targetPopulated}>
            <div style={{ marginTop: 32, marginBottom: 32 }}>
              <ActionButton style={{ color: '#FFFFFF' }} onClick={handleNextStep}>下一步 »</ActionButton>
            </div>
          </HideableContainer>
          <HideableContainer hidden={!ad.platform}>
            <div style={{ marginBottom: 25 }}>
              <AdCardSetting
                ad={ad}
                onChangeAd={setAd}
                disabled={!targetPopulated}
                active={activeCard === 'setting'}
                onSetActive={() => setActiveCard('setting')}
                handleValidFromAdSettings={handleValidFromAdSettings}
              />
            </div>
          </HideableContainer>
        </div>
        <HideableContainer hidden={!targetPopulated}>
          <div style={{ marginTop: 32, marginBottom: 32, display: 'flex' }}>
            <ActionButton
              style={{ marginRight: 24, color: '#FFFFFF' }}
              disabled={ad.validForCreation && validFromAdSettings ? false : true}
              onClick={saveAndReturnToDashboard}
            >
              建立這個廣告
            </ActionButton>
            <ActionButton
              style={{ display: 'none', color: '#FFFFFF', backgroundColor: ad.validForCreation && validFromAdSettings ? '#7C98CC' : undefined }}
              disabled={ad.validForCreation && validFromAdSettings ? false : true}
              onClick={saveAndContinueToSettings}
            >
              繼續素材設定
            </ActionButton>
          </div>
        </HideableContainer>
      </div>
      {popupAction && <ProcessionPopup onClose={() => { popupAction(); setPopupAction(); }} />}
    </div>
  );
}

export default AdSetting;
